
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-wiki",
      function () {
        return require("private-next-pages/create-wiki/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-wiki"])
      });
    }
  